// conversationActions.ts
import { hotelStaffActionTypes } from "./hotelStaffTypes";

export const hotelStaffApiResponseSuccess = (actionType: string, data: any) => ({
  type: hotelStaffActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

// Action to handle API error
export const hotelStaffApiResponseError = (actionType: string, error: string) => ({
  type: hotelStaffActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});






export const insertHotelStaffAction = (response: any) => ({
  type: hotelStaffActionTypes.INSERT_HOTEL_STAFF,
  payload: response
});


export const getAllHotelStaffAction = () => ({
  type: hotelStaffActionTypes.GET_ALL_STAFF,
  payload: {}
});



export const deleteHotelStaffAction = (response: any) => ({
  type: hotelStaffActionTypes.DELETE_STAFF,
  payload: response
});

